<template>
  <div>
    <div
      v-if="!showImportModal"
      class="modal-shadow saved_popup min-h-screen flex flex-col"
      @click.self="cancelPick"
    >
      <div class="inner">
        <div class="content">
          <div class="w-full flex justify-between modal_header p-6 title_line">
            <div class="modal_title mt-2">Upload routes CSV</div>
            <button type="button" class="x_btn" @click="cancelPick">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
          </div>

          <div class="modal_body flex flex-col items-center px-6 pb-6 pt-2">
            <p class="text-grey-dark text-sm mt-2 max-w-3xl mx-auto text-center">
              <button
                type="button"
                class="text-primary underline"
                @click="$emit('open-template')"
              >
                View example
              </button>
              for sample rows and download. Each non-empty row is one route;
              <code class="text-xs">start</code> is required;
              <code class="text-xs">departure</code> is optional (empty uses now).
              Up to 50 stops via <code class="text-xs">start</code> and
              <code class="text-xs">location1</code>…<code class="text-xs">location49</code>.
            </p>
            <input
              accept=".csv"
              ref="uploadCSVFile"
              type="file"
              hidden
              @change="fileUploaded()"
            >
            <div class="mt-6 flex flex-col items-center gap-3">
              <button
                type="button"
                class="btn green-white px-6"
                @click="openFilePicker"
              >
                Choose CSV file
              </button>
              <span class="text-grey-dark text-sm">
                {{ selectedFileName || 'No file chosen' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <RoutesCsvImportModal
      v-if="showImportModal && importRows.length"
      :rows="importRows"
      :display-headers="displayHeaders"
      @finished="finishImportFlow"
    />
  </div>
</template>

<script>
import parseFile from 'vue-xls-csv-parser/src/parser';
import RoutesCsvImportModal from '@/components/RoutesCsvImportModal';
import { infoMessage } from '@/services/messages';
import {
  csvHasLegacyWideHeaders,
  csvHasRoutePlannerHeaders,
  dedupeRoutePlannerDisplayHeaders,
  orderRoutePlannerDisplayHeaders,
  prepareImportRows,
  routePlannerFileJsonToRawRows,
} from '@/utils/routesRoutePlannerCsv';

export default {
  name: 'CSVUploadRoutes',
  inheritAttrs: false,
  components: {
    RoutesCsvImportModal,
  },
  data() {
    return {
      showImportModal: false,
      importRows: [],
      displayHeaders: [],
      selectedFileName: '',
    };
  },
  methods: {
    cancelPick() {
      this.$emit('cancel');
    },
    openFilePicker() {
      this.$refs.uploadCSVFile?.click();
    },
    finishImportFlow() {
      this.$emit('import-complete');
    },
    async fileUploaded() {
      const file = this.$refs.uploadCSVFile?.files?.[0];
      if (!file) {
        this.selectedFileName = '';
        return;
      }
      this.selectedFileName = file.name;
      try {
        const fileJson = await parseFile(file, 'en');
        const rawRows = routePlannerFileJsonToRawRows(fileJson);
        if (!rawRows.length) {
          infoMessage('No data rows found in CSV', 'error');
          return;
        }
        if (csvHasLegacyWideHeaders(rawRows)) {
          infoMessage(
            'The old wide routes CSV is no longer supported. Download the RoutePlanner template.',
            'error',
          );
          return;
        }
        if (!csvHasRoutePlannerHeaders(rawRows)) {
          infoMessage(
            'CSV must include a start column (RoutePlanner format).',
            'error',
          );
          return;
        }
        const rows = prepareImportRows(rawRows);
        if (!rows.length) {
          infoMessage('No route rows found in CSV', 'error');
          return;
        }
        this.displayHeaders = dedupeRoutePlannerDisplayHeaders(
          orderRoutePlannerDisplayHeaders(Object.keys(rawRows[0] || {})),
        );
        this.importRows = rows;
        this.showImportModal = true;
      } catch (error) {
        console.error(error);
        infoMessage('Could not parse CSV file', 'error');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-shadow {
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.39);
  z-index: 402;
}
.modal_header {
  border-radius: 8px 8px 0 0;
  border-bottom: none;
}
.saved_popup {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100vw;
}
.inner {
  margin: 40px auto;
  max-width: 640px;
  background: #fff;
  border-radius: 8px;
}
</style>
